<template>
  <CustCard>
    <template #header>
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h6 style="color: #101010;">
            {{ $l('form_header_budgetOrder') || '预算执行' }}
          </h6>
          <p style="font-size:12px;color: #6C6C6C;" class="m-0 text-truncate">
            {{ $l('form_desc_budgetOrder') || '根据客户预算统计执行情况' }}
          </p>
        </div>
        <div>
          <dict-select
            v-model="budgetYear"
            size="mini"
            url="/financial/order/budget/analysis/getBudgetYear"
          />
        </div>
      </div>
    </template>

    <div class="budget-year">
      <div class="budget-year-group">
        <div class="budget-year-mark">
          <div class="mark-value">{{ this.budgetYear }}</div>
          <div class="mark-label">
            {{ $l('form_label_budgetYear') || '预算年度' }}
          </div>
        </div>
        <div class="budget-year-mark">
          <div class="mark-value">{{ v_budgetAmount }}</div>
          <div class="mark-label">
            {{ $l('form_label_budgetAmount') || '预算金额' }}
          </div>
        </div>
        <div class="budget-year-mark">
          <div class="mark-value">{{ v_orderAmount }}</div>
          <div class="mark-label">
            {{ $l('form_label_orderAmount') || '订单金额' }}
          </div>
        </div>
      </div>
      <div class="budget-year-progress">
        <div class="d-flex justify-content-between mb-1">
          <span class="budget-year-progress-label">
            {{ $l('form_label_budgetProgress') || '预算完成率' }}
          </span>
          <span class="budget-year-progress-value">
            {{ `${budgetProgress}%` }}
          </span>
        </div>
        <b-progress
          variant="success"
          height="0.4rem"
          style="width: 100%"
          :value="budgetProgress"
          :max="100"
        />
      </div>
    </div>

    <div class="switch-tabs_wrappers mb-2 mt-3">
      <div class="switch-tabs">
        <div
          v-for="item in switchTabs"
          :key="item.value"
          class="switch-tabs_items"
          :class="{ active: item.value === activeTab }"
          @click="activeTab = item.value"
        >
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>

    <OrderTable
      v-show="activeTab == 'order'"
      :custCode="custCode"
      :rptYear="budgetYear"
    />
    <OrderGoodsTable
      v-show="activeTab == 'goods'"
      :custCode="custCode"
      :rptYear="budgetYear"
    />
  </CustCard>
</template>

<script>
import { format } from '@/libs/util.number.js'
import dayjs from 'dayjs'
import OrderTable from './order-table'
import OrderGoodsTable from './order-goods-table'
import CustCard from '../cust-card'
export default {
  components: { OrderTable, OrderGoodsTable, CustCard },
  props: { custCode: { type: String, default: '' } },
  data() {
    return {
      budgetYear: dayjs()
        .year()
        .toString(),
      budgetAmount: 0,
      orderAmount: 0,
      budgetProgress: 0,
      activeTab: 'order',
    }
  },
  computed: {
    v_budgetAmount() {
      return `$${format(this.budgetAmount) || '0'}`
    },
    v_orderAmount() {
      return `$${format(this.orderAmount) || '0'}`
    },
    switchTabs() {
      return [
        {
          label: this.$l('switchTabs_sub_label_budgetOrder') || '订单批次明细',
          value: 'order',
        },
        {
          label: this.$l('switchTabs_sub_label_budgetGoods') || '订单产品明细',
          value: 'goods',
        },
      ]
    },
  },
  watch: {
    budgetYear() {
      this.selectBudget()
    },
  },
  mounted() {
    this.selectBudget()
  },
  methods: {
    async selectBudget() {
      const res = await this.$api
        .customerReportBudgetYearApi({
          budgetYear: this.budgetYear,
          custCode: this.custCode,
        })
        .catch(() => null)
      if (!res) return
      const { annualBudget, orderAmount, completionRate } = res?.body || {}
      this.budgetAmount = annualBudget
      this.orderAmount = orderAmount
      this.budgetProgress = completionRate || 0
    },
  },
}
</script>
<style lang="scss" scoped>
.budget-year {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .budget-year-group {
    display: flex;
    .budget-year-mark {
      min-width: 120px;
      border-radius: 5px;
      margin-right: 20px;
      padding: 7px 10px;
      border: 1px dashed #e1e3ea;
      .mark-value {
        font-size: 18px;
        color: #101010;
        font-weight: 500;
      }
      .mark-label {
        font-size: 14px;
        color: #8e8e8e;
      }
    }
    .budget-year-mark:last-child {
      margin-right: 0;
    }
  }
  .budget-year-progress {
    width: 300px;
    .budget-year-progress-label {
      font-size: 14px;
      color: #8e8e8e;
    }
    .budget-year-progress-value {
      font-size: 16px;
      color: #101010;
      font-weight: 500;
    }
  }
}

.switch-tabs_wrappers {
  margin-top: 6px;
  .switch-tabs {
    display: flex;
    .switch-tabs_items {
      padding: 15px 2px 10px;
      color: #606266;
      font-size: 14px;
      margin-right: 26px;
      cursor: pointer;
      min-width: max-content;
      border-bottom: 3px solid transparent;
    }
    .switch-tabs_items:hover,
    .switch-tabs_items.active {
      color: #007bff;
      border-color: #1989fa;
    }
    .switch-tabs_items.disabled {
      cursor: no-drop;
    }
    .switch-tabs_items.disabled:hover {
      color: #8cc5ff;
      border-color: #7ab8f6;
    }
    .switch-tabs_items:last-child {
      margin-right: 0;
    }
  }
}
</style>
